// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IDepositAmountWidgetRequest,
  TDepositAmountWidgetModel,
  IMappers,
  TDepositAmountWidgetResponse,
  IDepositAmountWidgetResponse,
  IDepositAmountWidgetResponseError,
} from './types';

export const defaultConfig: TDepositAmountWidgetModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'billing-accounts',
  pathApi: '/v1/deposit-amount-widget/',
  requestType: 'json',
  responseType: 'json',
} as TDepositAmountWidgetModel;

export function createDepositAmountWidgetModel(parameters: IDepositAmountWidgetRequest): TDepositAmountWidgetModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDepositAmountWidgetOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IDepositAmountWidgetRequest;
}

export async function fetchDepositAmountWidget<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDepositAmountWidgetOptions<TResponse200, TResponse400>): Promise<
  TDepositAmountWidgetResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createDepositAmountWidgetModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDepositAmountWidgetResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IDepositAmountWidgetResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDepositAmountWidgetResponse;
}
